import PrimerCheckout from './PrimerCheckout';

export default PrimerCheckout;
